import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Result() {
  return (
    <section className="result_par p-100 text_color">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span>Results</span>
            </h2>
            <p>
              We provided unparalleled support to the client, from creating the
              project roadmap to deployment on the App Store. Parcheesi Cash is
              now available for free to iOS users, with certain in-app purchase
              features. The game boasts positive reviews from players across the
              globe and has an overall rating of 4.1 on the App Store.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/parcheesi-cash/id1604187763">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.nextgentechusa.parcheesicash">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/results.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={627}
                height={587}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
